import { useState, useEffect } from 'react';

function getInitialMatch(query: string): boolean {
  if (typeof window === 'undefined') return false;
  return window.matchMedia(query).matches;
}

export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState<boolean>(() => getInitialMatch(query));

  useEffect(() => {
    const mediaQueryList = window.matchMedia(query);
    setMatches(mediaQueryList.matches);

    const handleChange = (event: MediaQueryListEvent) => {
      setMatches(event.matches);
    };

    mediaQueryList.addEventListener('change', handleChange);
    return () => mediaQueryList.removeEventListener('change', handleChange);
  }, [query]);

  return matches;
}

/**
 * True below Tailwind's `md` breakpoint (768px). Use for swapping whole
 * component trees (table vs cards); prefer responsive classes for pure
 * layout shifts.
 */
export function useIsMobile(): boolean {
  return useMediaQuery('(max-width: 767px)');
}
